<template>
  <div class="slSet">
    <el-dialog
      class="abow_dialog"
      :title="status + '水库信息'"
      :close-on-click-modal="false"
      :visible.sync="addbtn">
      <el-form ref="groupForm" :model="form" :rules="rules" label-width="160px" label-height="40px">
        <el-form-item label="水库名称:" prop="reservoirName">
          <el-input v-model="form.reservoirName"></el-input>
        </el-form-item>
        <el-form-item label="乡镇:" prop="adcdid">
          <el-select v-model="form.adcdid" filterable clearable placeholder="请选择">
            <el-option
              v-for="item in mutiRanksAdcd"
              :key="'f'+item.value"
              :label="item.label"
              :value="item.value">
            </el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="水库类型：" prop="reservoirScale">
          <el-select v-model="form.reservoirScale" filterable clearable placeholder="请选择">
          <el-option
              v-for="item in reservoirScales"
              :key="'f'+item.name"
              :label="item.remark"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="坝型：">
          <el-select v-model="form.releaseType" filterable clearable placeholder="请选择">
          <el-option
              v-for="item in releaseTypes"
              :key="'f'+item.name"
              :label="item.name"
              :value="item.name">
            </el-option>
          </el-select>
        </el-form-item>
         <el-form-item label="经度:" prop="lng">
          <el-input v-model="form.lng"></el-input>
        </el-form-item>
        <el-form-item label="纬度:" prop="lat">
          <el-input v-model="form.lat"></el-input>
           <DrawPoint :globalmapId='globalmapId' :latlng='latlngarr' @changeAdd='handleChangeAdd'></DrawPoint>
        </el-form-item>
         <el-form-item label="集雨面积:" prop="rainfallArea">
            <el-input v-model="form.rainfallArea"></el-input>
            <label>(km²)</label>
        </el-form-item>
         <el-form-item label="坝高:" prop="damHeight">
          <el-input v-model="form.damHeight"></el-input>
          <label>(m)</label>
        </el-form-item>
         <el-form-item label="坝顶高程:" prop="bdgc">
          <el-input v-model="form.bdgc"></el-input>
          <label>(m)</label>
        </el-form-item>
          <el-form-item label="溢洪道高程:" prop="yhdgc">
          <el-input v-model="form.yhdgc"></el-input>
          <label>(m)</label>
        </el-form-item>
         <el-form-item label="校核洪水位:" prop="jhhsw">
          <el-input v-model="form.jhhsw"></el-input>
          <label>(m)</label>
        </el-form-item>
         <el-form-item label="设计洪水位:" prop="dsfllv">
          <el-input v-model="form.dsfllv"></el-input>
          <label>(m)</label>
        </el-form-item>
         <el-form-item label="死水位:" prop="ssw">
          <el-input v-model="form.ssw"></el-input>
          <label>(m)</label>
        </el-form-item>
         <el-form-item label="兴利（正常）水位:" prop="zcxsw">
          <el-input v-model="form.zcxsw"></el-input>
          <label>(m)</label>
        </el-form-item>
          <el-form-item label="总库容:" prop="storage">
          <el-input v-model="form.storage"></el-input>
          <label>(万m³)</label>
        </el-form-item>
         <el-form-item label="正常蓄水库容:" prop="zckr">
          <el-input v-model="form.zckr"></el-input>
          <label>(万m³)</label>
        </el-form-item>
        <el-form-item label="防洪库容:" prop="fhkr">
          <el-input v-model="form.fhkr"></el-input>
          <label>(万m³)</label>
        </el-form-item>
        <el-form-item label="兴利库容:" prop="xlkr">
          <el-input v-model="form.xlkr"></el-input>
          <label>(万m³)</label>
        </el-form-item>
        <el-form-item label="死库容:" prop="skr">
          <el-input v-model="form.skr"></el-input>
          <label>(万m³)</label>
        </el-form-item>
        <el-form-item label="旱限水位:" prop="hxsw">
          <el-input v-model="form.hxsw"></el-input>
          <label>(m)</label>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="addbtn = false">取 消</el-button>
        <el-button type="primary" @click="onGroupSave">保 存</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import scenceTypes from '@/store/types/scence'
import baseTypes from '@/store/types/base'
import Pager from '@/components/Pager'
import DrawPoint from '@/components/DrawPoint'
export default {
  props: ['addvcd'],
  components: {
    Pager,
    DrawPoint
  },
  data () {
    return {
      query: {
        adcdA: []
      },
      loading: false,
      height: 10,
      form: {},
      rules: {
        reservoirName: [
          { required: true, message: '水库名称不能为空' }
        ],
        adcdnm: [
          { required: true, message: '请选择乡镇' }
        ],
        reservoirScale: [
          { required: true, message: '请选择水库类型' }
        ],
        releaseType: [
          { required: true, message: '请选择坝型' }
        ],
        storage: [
          { required: true, message: '总库容不能为空' },
          { validator: this.Global.checkNumeral, trigger: 'blur' }
        ]
      },
      addbtn: false,
      pageIndex: 1,
      pageSize: 20,
      total: 0,
      cPageIndex: '1',
      cPageSize: '100',
      tdata: [],
      multipleSelection: [],
      status: '新增',
      aDCD: '330324',
      mutiRanksAdcd: [],
      all: true,
      cacds: [],
      rTypes: [],
      barrageTypes: [],
      releaseTypes: [],
      reservoirScales: [],
      getReservoirScale: 'Ⅰ,Ⅱ,Ⅲ,Ⅳ,Ⅴ',
      globalmapId: 'baseInfo',
      latlngarr: [],
      lat: 28.273886, // 新增初始经纬度坐标
      lng: 120.690968
    }
  },
  watch: {
    addvcd (val, oldVal) { // 普通的watch监听
      this.loading = true
      this.pageIndex = 1 // 重置页码
      this.query.adcd = val
      this.thedata()
    }
  },
  methods: {
    handleChangeAdd (data) {
      // this.form.lng = data.lng
      // this.form.lat = data.lat
      this.form.lng = this.$set(this.form, 'lng', data.lng)
      this.form.lat = this.$set(this.form, 'lat', data.lat)
    },
    onSizeChange (pageSize) {
      this.pageIndex = 1
      this.pageSize = pageSize
      this.thedata()
    },
    onCurrentChange (pageIndex) {
      this.pageIndex = pageIndex
      this.thedata()
    },
    searchTheData () {
      this.pageIndex = 1 // 重置页码
      this.getReservoirScale = this.query.reservoirScale ? this.query.reservoirScale : 'Ⅰ,Ⅱ,Ⅲ,Ⅳ,Ⅴ'
      this.thedata()
    },
    // 表头换行
    renderheader (h, { column, $index }) {
      return h('span', {}, [
        h('span', {}, column.label.split('@')[0]),
        h('br'),
        h('span', {}, column.label.split('@')[1])
      ])
    },
    getReservoirScaleName: function (row) {
      let reservoirScale = row.reservoirScale
      let option = this.reservoirScales.find(item => {
        return item.name === reservoirScale
      })
      let returnData = ''
      if (option !== undefined) {
        returnData = option.remark
      }
      return returnData
    },
    //  行选中
    clickRow (row) {
      this.$refs.multipleTable.toggleRowSelection(row)
    },
    thedata () {
      // this.$store.dispatch(scenceTypes.GET_RESERVOIR, { cacd: this.query.cacd, reservoirScale: this.query.reservoirScale, adcd: this.query.adcd, searchName: this.query.searchName, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
      //   this.tdata = data.results
      //   this.loading = false
      // })
      this.loading = true
      this.$store.dispatch(scenceTypes.GET_RESERVOIR, { cacd: this.query.cacd, reservoirScale: this.getReservoirScale, adcd: this.query.adcd, searchName: this.query.searchName, pageIndex: this.pageIndex, pageSize: this.pageSize }).then(data => {
        this.tdata = data.results
        this.total = data.total
        this.loading = false
      })
    },
    handleSelectionChange (val) {
      this.multipleSelection = val
    },
    // 新增
    addDialog () {
      this.status = '新增'
      this.latlngarr = [] // 重置经纬度
      this.form = {}
      // this.form = Object.assign({}, { lat: this.lat, lng: this.lng })
      // this.latlngarr.push(this.lng, this.lat)
      this.addbtn = true
      this.Global.clearValidate(this, 'groupForm')
    },
    // 编辑
    editDialog (row) {
      this.$store.dispatch(scenceTypes.GET_RESERVOIR, {
        stationId: row.stationId,
        pageIndex: 1,
        pageSize: 500
      }).then(data => {
        this.latlngarr = [] // 重置经纬度
        this.status = '编辑'
        this.form = Object.assign({}, data.results[0])
        this.addbtn = true
        this.latlngarr.push(this.form.lng, this.form.lat)
        this.Global.clearValidate(this, 'groupForm')
      })
    },
    // 删除
    delDialog () {
      if (this.multipleSelection.length < 1) {
        this.$alert('必需选择一条信息', '提示')
      } else {
        let ids = []
        this.multipleSelection.forEach(function (item) {
          ids.push(item.id)
        })
        this.$confirm(`确定要删除已选择的水库信息 ?`, '确认').then(() => {
          this.loading = true
          this.$store.dispatch(scenceTypes.DELETE_RESERVOIR, { id: ids.join(',') }).then(() => {
            this.multipleSelection = []
            this.$notify.success({ title: '成功', message: '删除数据成功.' })
            this.thedata()
            this.loading = false
          }).catch(() => { this.loading = false })
        }).catch(() => {})
      }
    },
    // 保存新增/编辑
    onGroupSave () {
      this.$refs['groupForm'].validate((valid) => {
        if (valid) {
          this.loading = true
          this.$store.dispatch(scenceTypes.SAVE_RESERVOIR, this.form).then(() => {
            this.$notify.success({ title: '成功', message: '保存成功。' })
            this.thedata()
            this.loading = false
            this.addbtn = false
            this.form = {}
            this.multipleSelection = []
          }).catch(() => { this.loading = false })
        }
      })
    },
    getCacd () {
      this.$store.dispatch(baseTypes.GET_CACD, { pageIndex: this.cPageIndex, pageSize: this.cPageSize }).then(data => {
        this.cacds = data.results
      }).catch(() => {})
    },
    getDict (type) {
      this.$store.dispatch(baseTypes.GET_DICT, { type: type }).then(data => {
        switch (type) {
          case 'ReservoirType':
            this.rTypes = data
            break
          case 'BarrageType':
            this.barrageTypes = data
            break
          case 'ReleaseType':
            this.releaseTypes = data
            break
          case 'ReservoirScale':
            let scaleData = data.filter(el => { // 工程类别不包含山塘
              return el.remark !== '山塘'
            })
            this.reservoirScales = scaleData
            break
          default:
        }
      }).catch(() => {})
    },
    getMutiRanksAdcd () {
      this.$store.dispatch(scenceTypes.GET_MUTIRANKS_ADCD, {
        parentAdcdCode: this.aDCD
      }).then(data => {
        this.mutiRanksAdcd = data.results
      })
    }
  },
  computed: {
    allowsPerm: {
      get () {
        return this.$store.state.allowPerm
      },
      set () {
        this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
      }
    }
  },
  created () {
    this.$store.dispatch('setAllowPerm', { name: this.$route.meta, type: this.$route.name })
    this.thedata()
    this.getCacd()
    this.getMutiRanksAdcd()
    this.getDict('ReservoirType')
    this.getDict('BarrageType')
    this.getDict('ReleaseType')
    this.getDict('ReservoirScale')
  },
  mounted () {
    this.$nextTick(() => {
      let sktDiv = document.getElementsByClassName('skt')
      this.height = sktDiv[0].offsetHeight - 120
    })
  }
}
</script>
<style scoped lang="less">
.slSet{
  /deep/ .el-dialog__wrapper{
    .el-dialog{
      margin-top: 10vh!important;
    }
  }
  /deep/ .el-form-item{
    float: left;
  }
}
.global_map {
  position: absolute;
  right: 15px;
  top: 5px;
}
</style>
